<template>
    <section class="section-featured-roles">
        <ContainerWithOffset >
            <div class="inner">
                <header class="section-header">
                    <h2 class="heading heading--lg text-uppercase">FEATURED Roles</h2>
                    <p class="paragraph">We're here. Where are you? Browse through our most wanted list and check
                        out some of the most sought-after roles here at Bohemia.</p>
                </header>
                <positions-slider v-if="list" :list="list"></positions-slider>
            </div>
        </ContainerWithOffset>
    </section>
</template>

<script>
  import ContainerWithOffset from "../common/ContainerWithOffset";
  import { getFeaturedPositions } from "../../services/featuredPositions";
  import PositionsSlider from "../sliders/JobsPositionsSlider";



  export default {

    name: "featured-roles",
    components: {
      ContainerWithOffset,
      PositionsSlider,

    },
    data() {
      return {
        list: null
      };
    },
    methods: {
      async getFeatured() {

        try {
          const response = await getFeaturedPositions();
          this.list = response.filter((item) => {
            if (item.position_id) {
              return true;
            }
          });

        } catch (e) {
          console.log("error loading featured positions");
        }
      }
    },
    async mounted() {
      await this.getFeatured();

    }

  };
</script>

<style scoped lang="scss">
    @import "../../assets/scss/globals";


    .section-featured-roles {
        background: white;
        // background-color: #000;
        margin-top: 10em;
        @media(max-width: $mq-md-max) {
            margin-top: 0;
        }

    }

    .inner {
        padding-right: 0px;
        padding-left: 0px;

    }

    header.section-header {
        padding-bottom: 26px;
        padding-left: 3%;


        .heading {
            color: $text-strong;

            @media(max-width: $compact) {
                padding: 25px;

            }
        }

        .paragraph {
            font-size: 18px;
            width: 51%;
            margin-top: 20px;
            line-height: 1.55;

            @media(max-width: $compact) {
                padding: 20px;
            }

            @media (max-width: $mq-sm-max) {
                width: auto;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/FeaturedRoles.vue